var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "W2P",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.500000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2B2B2B",
    points: "0.533333333 0 24 0 24 24.1451028 0 24.1451028 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B7B7B7",
    points: "7.73333333 22.9825608 7.73333333 8.04836759 1.06666667 8.04836759 1.06666667 22.9825608"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B7B7B7",
    points: "8.8 8.04836759 8.8 22.9825608 22.8444444 22.9825608 22.8444444 8.04836759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B7B7B7",
    points: "1.06666667 6.88582561 22.8444444 6.88582561 22.8444444 1.07311568 1.06666667 1.07311568"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.63f9174c17c774861941b44101b15bd8.svg";
export { ForwardRef as ReactComponent };